import usFlagImg from '../assets/static/icon-us-flag.png';
import caFlagImg from '../assets/static/icon-ca-flag.png';

export interface AppConfigDict {
    country: string
    target?: string
}

class AppConfig {
    country: string
    target?: string

    constructor(dict: AppConfigDict) {
        const country = ["us", "ca"].includes(dict.country) ? dict.country : "us"
        this.country = country;
        this.target = dict.target;
    }

    get isAndroid(): boolean {
        return this.target === "android";
    }

    get isIos(): boolean {
        return this.target === "ios";
    }

    get isStaging(): boolean {
        return this.target === "staging";
    }

    get isLegacy(): boolean {
        return this.target === "legacy";
    }

    getPlatform() {
        if (this.isAndroid) return "Android";
        if (this.isIos) return "iOS";
        return "Web";
    }

    isProduction() {
        return !this.isStaging;
    }

    getFirebaseDocumentIds(): string[] {
        if (this.country === "us") {
            return this.getFirebaseDocumentIdsUS();
        } else if (this.country === "ca") {
            return this.getFirebaseDocumentIdsCA();
        }

        return this.getFirebaseDocumentIdsUS();
    }

    getFirebaseDocumentIdsUS(): string[] {
        return ["fda", "usda", "other"];
    }

    getFirebaseDocumentIdsCA(): string[] {
        return ["cfia"];
    }

    getFirebaseDocumentPathV1(documentId: string): string {
        var firebaseDoc = `Recalls/Web/${documentId}/All`
        if (this.isAndroid) {
            firebaseDoc = `Recalls/Android/${documentId}/All`
        } else if (this.isStaging) {
            firebaseDoc = `Recalls/Staging/${documentId}/All`
        } else if (this.isIos) {
            firebaseDoc = `Recalls/iOS/${documentId}/All`
        } else if (this.isLegacy) {
            firebaseDoc = `Recalls/${documentId}/Recent/All`
        } else {
            firebaseDoc = `Recalls/Web/${documentId}/All`
        }
        return firebaseDoc;
    }

    getFirebaseDocumentPathV2(documentId: string): string {
        var firebaseDoc = `Recalls/v2/${this.country}/${documentId}/${this.target ?? "web"}/all`
        
        return firebaseDoc;
    }

    setCountry(country: string) {
        this.country = country
    }

    getPrettyCountryDescription(): string {
        return AppConfig.getPrettyCountryDescription(this.country);
    }

    static getPrettyCountryDescription(country?: string): string {
        if (country === "us") {
            return "the US";
        } else if (country === "ca") {
            return "Canada"
        } else {
            return "the US";
        }
    }

    static getFlag(country?: string): string {
        if (country === "us") {
            return "🇺🇸";
        } else if (country === "ca") {
            return "🇨🇦"
        } else {
            return "🇺🇸";
        }
    }

    static getFlagImg(country?: string): string {
        let flagImg = (country === "ca" ? caFlagImg : usFlagImg);

        return flagImg;
    }
}


export default AppConfig;
